module.exports = __webpack_public_path__ + "static/media/labeledaddress.464fc0df.svg";